var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.667,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.717 11.182-2.6-2.6a.4.4 0 0 1 0-.566l.566-.565a.4.4 0 0 1 .566 0L7 9.202l3.752-3.751a.4.4 0 0 1 .565 0l.566.565a.4.4 0 0 1 0 .566l-4.6 4.6a.4.4 0 0 1-.566 0Z",
    fill: "#fff"
  })));
};

export default SvgCheckCircle;